var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mall-banner"},[_c('div',{staticClass:"container mall-banner-content"},[_c('div',{staticClass:"mall-banner-search"},[_vm._t("search")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }